export default [
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/views/modules/skeleton/admin/Logs/Logs.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Logs',
          active: true,
          // back: true
        },
      ],
    },
  },
]
